export type ServerVerificationKind = "official" | "verified";

const OFFICIAL_SERVER_FLAG = 1;
const VERIFIED_SERVER_FLAG = 2;

export const SERVER_VERIFICATION_MARK = {
  size: 18,
  viewBox: "0 0 24 24",
  opticalOffsetY: 1,
} as const;

/**
 * Resolve the single verification mark shown beside a server name.
 * Official takes precedence when both backend flags are present.
 */
export function getServerVerificationKind(
  flags: number,
): ServerVerificationKind | null {
  if ((flags & OFFICIAL_SERVER_FLAG) !== 0) return "official";
  if ((flags & VERIFIED_SERVER_FLAG) !== 0) return "verified";
  return null;
}
